<template>
  <v-text-field v-bind="$props" v-on="$listeners">
    <template
      v-for="slot in Object.keys($scopedSlots)"
      :slot="slot"
      slot-scope="scope"
    >
      <slot :name="slot" v-bind="scope" />
    </template>
  </v-text-field>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import dayjs from 'dayjs';

export default {
  name: 'TotalTimeField',
  extends: VTextField,

  props: {
    filled: { default: true },
    startTime: { default: '00:00' },
    endTime: { default: '00:00' },
  },
  computed: {
    diff() {
      const { startTime, endTime } = this;
      const date1 = dayjs(`1900-01-01 ${startTime}`);
      const date2 = dayjs(`1900-01-01 ${endTime}`);
      return date2.diff(date1, 'minute');
    },
  },
  watch: {
    diff() {
      this.$emit('input', this.diff);
    },
  },
};
</script>
